module.exports = __webpack_public_path__ + "static/img/ipllettermark.876d90d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ipllettermark.svg
// module id = TJDc
// module chunks = 1